import React, { Component } from "react";
import "./Video.css";

export default class Video extends Component {
  render() {
    function getId(url) {
      let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      let match = url.match(regExp);
      if (match && match[2].length === 11) {
        return match[2];
      } else {
        return "error";
      }
    }

    const youtubeParams =
      "autoplay=0&disablekb=0&controls=1&iv_load_policy=3&rel=0&showinfo=0&modestbranding=1";
      const pandaParams =
      "controls=play-large,play,progress,current-time, volume,captions,settings,pip,fullscreen";
    const vimeoParams = "title=0&byline=0&portrait=0&playsinline=0&autopause=0";
    const url = this.props.url;

    const params = url.search("vimeo") > -1 ? vimeoParams : url.search("panda") ? pandaParams : youtubeParams;

    return (
      <div id="video">
        <iframe
          id = "panda-54410c0c-c053-48f7-aac6-24d2e947a961"
          src={`${url}?${params}`}
          frameBorder="0"
          allow="autoplay; encrypted-media; fullscreen"
          allowFullScreen
          title="Chat"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/video/Video.js